module.exports = __webpack_public_path__ + "img/19.2523eca9.jpg";